import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createBlock as _createBlock, KeepAlive as _KeepAlive, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4501336c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["id", "aria-labelledby", "aria-describedby"]
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "icon"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = ["id"]
const _hoisted_8 = ["id"]
const _hoisted_9 = ["id"]
const _hoisted_10 = {
  key: 4,
  class: "btn-close",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Chiudi finestra modale",
  style: {"min-width":"44px","min-height":"44px"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("use", { href: "/dist/svg/sprites.svg#it-close" })
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "modal-footer" }

import {computed, onBeforeMount, onMounted, Ref, watch} from "vue";
import {IModal} from "@/interfaces/components/general/IModal";
//@ts-ignore
import {Modal} from 'bootstrap-italia';
import BottomSheet from "@/components/general/BottomSheet.vue";
import {IBottomSheet} from "@/interfaces/components/general/IBottomSheet";
import {idRandomGenerator} from "cdp-fe-commons-layout";

import { useServiceDetailStore } from "@/stores/service/serviceDetail";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomModal',
  props: {
    customId: { default: idRandomGenerator() },
    modal: null
  },
  emits: ["shown", "hidden"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'shown', id: string): void,
  (e: 'hidden', id: string): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { customId: string, modal: IModal }

const serviceDetailStore = useServiceDetailStore();






const computedModal = computed(() => props.modal)
  console.debug('computedModal',computedModal)
const computedBottomSheet: Ref<IBottomSheet | undefined> = computed(() => {
  if (computedModal.value?.bottomSheet === true) {
    return {
      title: computedModal.value.title,
      titleEn: computedModal.value.titleEn,
      content: computedModal.value.content,
      show: computedModal.value.show
    } as IBottomSheet
  }
})

console.debug('computedBottomSheet',computedBottomSheet)

let modalBootstrap: any | null = null;

onMounted(() => {
  const modalElement: HTMLElement | null = document.getElementById(props.customId)
  if (modalElement !== null) {
    modalBootstrap = Modal.getOrCreateInstance(modalElement);
    modalElement.addEventListener('hidden.bs.modal', function () {
      emits('hidden', props.customId)
      removeFade()
    })
    modalElement.addEventListener('shown.bs.modal', function () {
      emits('shown', props.customId)
    })
  }
})

function removeFade() {
  const fade: Element | null = document.getElementsByClassName("modal-backdrop fade show").item(0);
  if (fade !== null) {
    fade.remove();
  }
}

onBeforeMount(() => {
  if (!computedModal.value.show) {
    removeFade();
  }
})

watch(computedModal, (value) => {
  if (modalBootstrap !== null && value.show) {
    modalBootstrap.toggle();
  }
}, {deep: true})

watch(() => computedModal.value.show, (value, oldValue) => {
  if (modalBootstrap !== null && oldValue != undefined && value !== oldValue) {
    modalBootstrap.toggle();
  }
})


return (_ctx: any,_cache: any) => {
  return (_unref(computedBottomSheet))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(BottomSheet, { "bottom-sheet": _unref(computedBottomSheet) }, null, 8, ["bottom-sheet"])
      ]))
    : (_unref(computedModal))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass((_unref(computedModal).icon ? 'alert-modal ' : '') + 'modal fade'),
          id: __props.customId,
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": __props.customId+'ModalLabel',
          "aria-describedby": _unref(computedModal).title
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('modal-dialog ' + _unref(computedModal).dimension)
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_unref(computedModal).icon)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                      _createElementVNode("use", {
                        href: '/dist/svg/sprites.svg#'+_unref(computedModal).icon
                      }, null, 8, _hoisted_6)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(computedModal).title && _unref(serviceDetailStore).language=='it')
                  ? (_openBlock(), _createElementBlock("h1", {
                      key: 1,
                      class: "modal-title h5 no_toc",
                      id: __props.customId+'ModalLabel'
                    }, _toDisplayString(_unref(computedModal).title), 9, _hoisted_7))
                  : _createCommentVNode("", true),
                (_unref(computedModal).titleEn && _unref(serviceDetailStore).language=='en')
                  ? (_openBlock(), _createElementBlock("h1", {
                      key: 2,
                      class: "modal-title h5 no_toc",
                      id: __props.customId+'ModalLabel'
                    }, _toDisplayString(_unref(computedModal).titleEn), 9, _hoisted_8))
                  : (_openBlock(), _createElementBlock("h2", {
                      key: 3,
                      class: "visually-hidden",
                      id: __props.customId+'ModalLabel'
                    }, "titolo modale", 8, _hoisted_9)),
                (_unref(computedModal).closable)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_10, _hoisted_12))
                  : _createCommentVNode("", true)
              ]),
              (_unref(computedModal).content)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass('modal-body ' + _unref(computedModal).customClass ? _unref(computedModal).customClass : '')
                  }, [
                    (_openBlock(), _createBlock(_KeepAlive, null, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(computedModal).content.render), _mergeProps({
                        class: _unref(computedModal).content.customClass ?? ''
                      }, _toHandlers(_unref(computedModal).content.events ?? []), _unref(computedModal).content.content ?? {}), null, 16, ["class"]))
                    ], 1024))
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(), _createBlock(_KeepAlive, null, [
                  (_unref(computedModal).footer)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(computedModal).footer.render), _mergeProps({
                        key: 0,
                        class: _unref(computedModal).footer.customClass ?? ''
                      }, _toHandlers(_unref(computedModal).footer.events ?? []), _unref(computedModal).footer.content ?? {}), null, 16, ["class"]))
                    : _createCommentVNode("", true)
                ], 1024))
              ])
            ])
          ], 2)
        ], 10, _hoisted_2))
      : _createCommentVNode("", true)
}
}

})